// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZfeVZ","tree":"styles_tree__dGpUs","table":"styles_table__fMlTT","cell":"styles_cell__S07ij"};